<div id="container" [style.background-color]="color">
    <img src={{imgSrc}} alt="" *ngIf="!!imgSrc && !badgeText" class="badge-img">
    <label *ngIf="!!badgeText && !imgSrc">
        {{badgeText}}
    </label>
</div>